import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import api from '@/api';
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
export default {
  namespaced: true,
  state: {
    showDialog: false
  },
  mutations: {},
  actions: {
    /**
     * @description 删除操作
     * @param {Object} context
     * @param {*} info info
     */
    deleteList: function deleteList(_ref, _ref2) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var dispatch, _ref2$req, req, _ref2$data, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch = _ref.dispatch;
                _ref2$req = _ref2.req, req = _ref2$req === void 0 ? '' : _ref2$req, _ref2$data = _ref2.data, data = _ref2$data === void 0 ? {} : _ref2$data;
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  MessageBox.confirm("此操作将删除数据, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            api[req](data).then(function (res) {
                              if (res.code == 0) {
                                Message({
                                  type: "success",
                                  message: "删除成功!"
                                });
                                resolve();
                              }
                            });

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }))).catch(function (err) {});
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    set: function set(_ref4, data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref4.state, dispatch = _ref4.dispatch;
                // store 赋值
                state.showDialog = data; // 持久化

                _context3.next = 4;
                return dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'method.showDialog',
                  value: data,
                  user: false
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};